var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#2E343D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24219 8.36719C4.14453 8.28906 4.14453 8.13281 4.24219 8.03516L8.32422 3.95312C8.42188 3.85547 8.55859 3.85547 8.65625 3.95312L12.7383 8.03516C12.8359 8.13281 12.8359 8.28906 12.7383 8.36719L12.3672 8.75781C12.2695 8.85547 12.1133 8.85547 12.0352 8.75781L9.00781 5.73047V12.3906C9.00781 12.5273 8.89062 12.625 8.77344 12.625H8.22656C8.08984 12.625 7.99219 12.5273 7.99219 12.3906V5.73047L4.94531 8.75781C4.86719 8.85547 4.71094 8.85547 4.61328 8.75781L4.24219 8.36719Z",
    fill: "#00B976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUpArrow);
export default __webpack_public_path__ + "static/media/greenUpArrow.420d3817c420368b98eabd65d228b1d5.svg";
export { ForwardRef as ReactComponent };